/** 教培列表页通用分页 / 重置（对齐小红书活动后管） */
export default {
  methods: {
    onPageChange(page) {
      if (!this.query) return
      this.query.page = page - 1
      this.loadList()
    },
    onSizeChange(size) {
      if (!this.query) return
      this.query.size = size
      this.query.page = 0
      this.loadList()
    },
    /** @param {Object} defaults 各页定义的默认 query 字段 */
    resetListQuery(defaults) {
      if (!this.query) return
      const size = (defaults && defaults.size) || this.query.size || 20
      Object.keys(this.query).forEach(k => {
        this.$set(this.query, k, undefined)
      })
      Object.assign(this.query, defaults, { page: 0, size })
      this.loadList()
    }
  }
}
